import { useEffect, useState } from "react";

import Shepherd from "shepherd.js";
import "./shepherd.scss";

import { useTypedDispatch, useTypedSelector } from "hooks/store";
import {
    CurrentDrawerOpenType,
    toggleDrawer,
    updateDrawerTitle,
} from "state/slices/RightDrawerSlice";
import fn from "utils/function";
import { DialogOpenType, openDialog } from "state/slices/DialogSlice";
const shepherd = (): void => {
    const currentModel = useTypedSelector<CurrentDrawerOpenType>((store) => store.ModelWindow.type);
    const dispatch = useTypedDispatch();
    const isOpen = useTypedSelector((store) => store.ModelWindow.isModelOpen);
    const [device, setDevice] = useState("desktop");

    const isLoading = useTypedSelector((store) => store.Loading.isLoading);
    const isTimeOut = useTypedSelector((store) => store.Loading.isTimeout);

    const handleToggleModel = (): void => {
        detectDevice();
        if (isOpen) {
            dispatch(toggleDrawer(currentModel));
        } else {
            dispatch(toggleDrawer(CurrentDrawerOpenType.AddObject));
            dispatch(updateDrawerTitle("Select a New Item to place into the OR"));
        }
    };

    const detectDevice = (): void => {
        if (fn.isMobile()) {
            setDevice("mobile");
            return;
        }
        if (device !== "desktop") {
            setDevice("desktop");
        }
    };

    useEffect(() => {
        detectDevice();
    }, [isOpen]);

    useEffect(() => {
        const tour = new Shepherd.Tour({
            defaultStepOptions: {
                cancelIcon: {
                    enabled: true,
                },
                scrollTo: { behavior: "smooth", block: "center" },
            },
        });

        tour.addStep({
            title: "Step 1",
            text: `Click on side menu to select new items for the scene.`,
            classes: "custom-step-pos",
            buttons: [
                {
                    action() {
                        handleToggleModel();
                        return this.next();
                    },
                    text: "Next",
                },
            ],
        });

        tour.addStep({
            title: "Step 2",
            text: `Click on the Trocar on the side menu to add ports to the patient. \ You can reposition the ports as needed by dragging them on the torso`,
            classes: "custom-step-pos",
            buttons: [
                {
                    action() {
                        handleToggleModel();
                        return this.back();
                    },
                    classes: "shepherd-button-back",
                    text: "Back",
                },
                {
                    action() {
                        return this.next();
                    },
                    text: "Next",
                },
            ],
        });

        tour.addStep({
            title: "Step 3",
            text: `A single click on the port will open the Trocar menu. \ You can angle and rotate the trocar on the menu by using the sliders`,
            classes: "custom-step-pos",
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: "shepherd-button-back",
                    text: "Back",
                },
                {
                    action() {
                        return this.next();
                    },
                    text: "Next",
                },
            ],
        });

        tour.addStep({
            title: "Step 4",
            text: `To add a BSU to the scene click on the BSU icon on the main side menu. \ Click on the BSU in the scene to rotate it or to change it's height. \ Drag it into your desired position.`,
            classes: "custom-step-pos",
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: "shepherd-button-back",
                    text: "Back",
                },
                {
                    action() {
                        return this.next();
                    },
                    text: "Next",
                },
            ],
        });

        tour.addStep({
            title: "Step 5",
            text: `To connect a BSU to a port, click on the Trocar and then select the colour of the BSU you want to connect it to from the Trocar menu.`,
            classes: "custom-step-pos",
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: "shepherd-button-back",
                    text: "Back",
                },
                {
                    action() {
                        dispatch(openDialog({ isDialogOpen: true, type: DialogOpenType.SaveRoom }));
                        handleToggleModel();
                        return this.next();
                    },
                    text: "Next",
                },
            ],
        });

        tour.addStep({
            title: "Step 6",
            text: `To save a set up, take a screen shot of your OR using the camera icon. \ To annotate your scene, add sticky notes to your image and save to your desktop`,
            classes: "custom-step-pos step-6",
            buttons: [
                {
                    action() {
                        dispatch(
                            openDialog({ isDialogOpen: false, type: DialogOpenType.SaveRoom })
                        );
                        handleToggleModel();
                        return this.back();
                    },
                    classes: "shepherd-button-back",
                    text: "Back",
                },
                {
                    action() {
                        return this.next();
                    },
                    text: "Finish",
                },
            ],
        });

        if (isLoading && isTimeOut) {
            // Check is introduction cookie is exists.
            if (!fn.isIntroductionCookieAvailable()) {
                // Set introduction cookie.
                fn.setIntroductionCookie();
                tour.start();
            }
        }

        return function cleanup() {
            tour.cancel();
        };
    }, [isLoading, isTimeOut]);
};

export default shepherd;
